import { memo } from "react";
import { StyleSheet, useUnistyles } from "react-native-unistyles";
import { View } from "@src/components/View";
import { ActivityIndicator, ScrollView } from "react-native";
import { useLayoutEffect } from "react";
import { Stack, useNavigation } from "expo-router";
import { AdminsSection } from "@src/features/settings/components/AdminsSection";
import { SiteAccessSection } from "@src/features/settings/components/SiteAccessSection";
import { useHeaderBackButton } from "@src/hooks/useHeaderBackButton";
// @ts-expect-error baseline 2026-02-16
import { WebLayout } from "@src/components/web";
import { Card, Text } from "@src/components";
import { isWeb } from "@src/utils/web-helpers";
import { useUsersAndPermissionsData } from "@src/features/settings/hooks";

const UsersAndPermissionsScreen = memo(() => {
  const { theme } = useUnistyles();
  const navigation = useNavigation();
  const { headerLeft } = useHeaderBackButton();

  const { isReady, isError } = useUsersAndPermissionsData();

  useLayoutEffect(() => {
    navigation.setOptions({
      title: "Users & Permissions",
      headerLeft,
      headerStyle: {
        backgroundColor: theme.colors.background,
      },
    });
  }, [navigation, theme.colors.background, headerLeft]);

  if (isWeb) {
    return (
      <>
        <Stack.Screen options={{ headerShown: false }} />
        <WebLayout>
          <ScrollView style={styles.scrollView} contentContainerStyle={styles.contentContainerStyle}>
            <Text textStyle="lg/semibold" color="text" mb="3xl">
              Users & Permissions
            </Text>
            {isError ?
              <Text textStyle="sm/regular" color="textMuted" style={styles.errorMessage}>
                Something went wrong. Please try again.
              </Text>
            : !isReady ?
              <ActivityIndicator style={styles.loader} />
            : <View gap="3xl" flexDirection="row" alignItems="flex-start">
                <Card flex={1}>
                  <AdminsSection title="Organisation admins" />
                </Card>
                <Card flex={1}>
                  <SiteAccessSection title="Site access" subtitle="See users with site-specific access." />
                </Card>
              </View>
            }
          </ScrollView>
        </WebLayout>
      </>
    );
  }

  if (isError) {
    return (
      <View flex={1} alignItems="center" justifyContent="center" padding="3xl">
        <Text textStyle="sm/regular" color="textMuted" textAlign="center">
          Something went wrong. Please try again.
        </Text>
      </View>
    );
  }

  if (!isReady) {
    return (
      <View flex={1} alignItems="center" justifyContent="center">
        <ActivityIndicator />
      </View>
    );
  }

  return (
    <ScrollView style={styles.scrollView} contentContainerStyle={styles.contentContainerStyle}>
      <View gap="9xl">
        <AdminsSection title="Organisation admins" />
        <SiteAccessSection title="Site access" />
      </View>
    </ScrollView>
  );
});

export default UsersAndPermissionsScreen;

const styles = StyleSheet.create((theme) => ({
  scrollView: {
    flex: 1,
  },
  contentContainerStyle: {
    flexGrow: 1,
    padding: theme.spacing["3xl"],
  },
  loader: {
    paddingVertical: theme.spacing["9xl"],
  },
  errorMessage: {
    paddingVertical: theme.spacing["9xl"],
    textAlign: "center",
  },
}));
